import { ErrorIcon, InfoIcon, SuccessIcon, WarningIcon } from './customIcons';

import type { BaseTheme } from '.';
import type { InterpolationConfig } from '../../@types/settings';
import type { Theme } from '@mui/material/styles';
import type { Components } from '@mui/material/styles/components';

// ----------------------------------------------------------------------

const isLight = (theme: Theme): boolean => theme.palette.mode === 'light';

const standardStyle =
  (color: string) =>
  ({ theme }: InterpolationConfig) => ({
    color: theme.palette[color][isLight(theme) ? 'darker' : 'lighter'],
    backgroundColor:
      theme.palette[color][isLight(theme) ? 'lighter' : 'darker'],
    '& .MuiAlert-icon': {
      color: theme.palette[color][isLight(theme) ? 'dark' : 'light'],
    },
  });

const filledStyle =
  (color: string) =>
  ({ theme }: InterpolationConfig) => ({
    color: theme.palette[color].contrastText,
  });

const outlinedStyle =
  (color: string) =>
  ({ theme }: InterpolationConfig) => ({
    color: theme.palette[color][isLight(theme) ? 'darker' : 'lighter'],
    border: `solid 1px ${
      theme.palette[color][isLight(theme) ? 'light' : 'dark']
    }`,
    backgroundColor:
      theme.palette[color][isLight(theme) ? 'lighter' : 'darker'],
    '& .MuiAlert-icon': {
      color: theme.palette[color][isLight(theme) ? 'dark' : 'light'],
    },
  });

// export const alert: Components<Omit<Theme, 'components'>> = {
export const alert: Components<BaseTheme> = {
  MuiAlert: {
    defaultProps: {
      iconMapping: {
        error: ErrorIcon,
        info: InfoIcon,
        success: SuccessIcon,
        warning: WarningIcon,
      },
    },

    styleOverrides: {
      message: ({ theme }) => ({
        '& .MuiAlertTitle-root': {
          marginBottom: theme.spacing(0.5),
        },
      }),
      action: ({ theme }) => ({
        '& button:not(:first-of-type)': {
          marginLeft: theme.spacing(1),
        },
      }),
      icon: {
        '& svg': {
          width: 24,
          height: 24,
        },
      },

      standardInfo: standardStyle('info'),
      standardSuccess: standardStyle('success'),
      standardWarning: standardStyle('warning'),
      standardError: standardStyle('error'),

      filledInfo: filledStyle('info'),
      filledSuccess: filledStyle('success'),
      filledWarning: filledStyle('warning'),
      filledError: filledStyle('error'),

      outlinedInfo: outlinedStyle('info'),
      outlinedSuccess: outlinedStyle('success'),
      outlinedWarning: outlinedStyle('warning'),
      outlinedError: outlinedStyle('error'),
    },
  },
};
